// ============================================================
// „Live-Verbindung unterbrochen" (SPEC §13.6). Ein Bildschirm, der `useEreignisse`
// hängt, meldet seinen Zustand über `useLive` — die Leiste selbst steht EINMAL in
// der Schale, damit zwei Bildschirme nicht zwei Leisten zeichnen.
//
//   const { verbunden } = useEreignisse({ katalogId });
//   useLiveMelden(verbunden);
// ============================================================
import { useEffect } from "react";
import { create } from "zustand";
import { Icon } from "../ui";
import { useT } from "../../lib/texte";

interface LiveZustand {
  getrennt: boolean;
  setzen(getrennt: boolean): void;
}

export const useLive = create<LiveZustand>((set) => ({
  getrennt: false,
  setzen(getrennt) {
    set({ getrennt });
  },
}));

/** Der Bildschirm meldet, ob seine Live-Verbindung steht; beim Verlassen zurück auf „steht". */
export function useLiveMelden(verbunden: boolean): void {
  const setzen = useLive((s) => s.setzen);
  useEffect(() => {
    setzen(!verbunden);
    return () => setzen(false);
  }, [verbunden, setzen]);
}

export function LiveLeiste() {
  const getrennt = useLive((s) => s.getrennt);
  const { t } = useT();
  if (!getrennt) return null;
  return (
    <div className="live-leiste anim-fade" role="status">
      <Icon name="arrows-clockwise" size={15} />
      {t.live.unterbrochen}
    </div>
  );
}
